import React, { useState, useEffect, useMemo } from "react";
import "bootstrap/dist/css/bootstrap.css";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { updateAlert, updateSourceInputs } from "../../../../redux/actions";
import SearchBar from "../../../../components/Searchbar/searchbar";

function Filters(props) {
  const { match, children } = props;

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      {/* <SearchBar
        handleSearchValue={handleSearchValue}
        placeholder={`Search with ${
          (
            props?.source_data?.data?.dropdown?.search_filter_details
              ?.search_filter_attributes || []
          )
            .map((attr) => attr?.label)
            .filter(Boolean)
            .join(", ") || "..."
        }`}
        value={props?.source_data?.searchValue ?? ""}
      /> */}
    </div>
  );
}

Filters.propTypes = {
  user: PropTypes.object,
};

const mapStateToProps = (state) => ({
  user: state.user,
});

const mapDispatchToProps = {
  updateAlert,
  updateSourceInputs,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Filters),
);
